module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18453/js/img/valuePropModals/ReportBuilder/ValueProp2.svg"